import React from "react";

export function RegisterForm({ 
  t, 
  email, 
  setEmail, 
  pass, 
  setPass, 
  pass2, 
  setPass2, 
  loading, 
  setLoading, 
  onRegister, 
  addToast 
}) {
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await onRegister(email, pass, pass2);
    } catch (err) {
      addToast(err.message, "error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <div className="form-group">
        <label className="form-label">{t.email}</label>
        <div className="form-input-wrap">
          <span className="form-input-icon">✉</span>
          <input
            className="form-input"
            type="email"
            placeholder={t.emailPlaceholder}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t.password}</label>
        <div className="form-input-wrap">
          <span className="form-input-icon">🔒</span>
          <input
            className="form-input"
            type="password"
            placeholder={t.passwordPlaceholder}
            value={pass}
            onChange={(e) => setPass(e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      <div className="form-group">
        <label className="form-label">{t.confirmPassword}</label>
        <div className="form-input-wrap">
          <span className="form-input-icon">🔒</span>
          <input
            className="form-input"
            type="password"
            placeholder={t.passwordPlaceholder}
            value={pass2}
            onChange={(e) => setPass2(e.target.value)}
            disabled={loading}
          />
        </div>
      </div>
      <button className="btn-primary" type="submit" disabled={loading}>
        {loading ? "…" : t.createAccount}
      </button>
    </form>
  );
}